import IconComponent from './IconComponent';

export default function AgentIcon() {
	return <IconComponent iconUrl="https://cdn.jsdelivr.net/npm/lucide-static@1.23.0/icons/bot.svg?currentColor=true" preserveAspectRatio />;
}
